// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Mtam","boxTitle":"Qualiphy_boxTitle__35ezh","box":"Qualiphy_box__2NJE0","toggleWrap":"Qualiphy_toggleWrap__2tQOm"};